export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/GB-8d7e0c569f553eeb5dcbc98a5811a811.png";